import Common from '../common/Common';
import PurpleUrl from '../purple/PurpleUrl';
import gsap from "gsap";
import { PURPLE_SCHEME_TYPE, PLATFORM } from '../common/const';
import ncuiModal from '@ncui/md-modal';
import '@ncui/md-modal/styles'
import { isIosCheck, isAndroidCheck } from '../common/util';
class PlatformDownload {
    constructor({ data, l10nData }) {
        if(!data || !l10nData) {
            return;
        }

        this.com = Common.instance;

        this.data = data;
        this.l10nData = l10nData;
        this.isMobile = this.com?.isMobile;
        this.isPurpleApp = this.com?.purpleCheck?.isPurpleApp;
        this.platform = this.com?.platform;
    }

    makeMarkup() {
        const platformData = this.data?.platformDownload;
        const platformDataLength = Array.isArray(platformData) && platformData.length > 0 ? platformData.length : 0;
        const downloadTagText = this.l10nData.download || 'Download';
        let innerTmpl = '';
        
        if(this.isMobile) {
            // 모바일일 경우 생성 안함. startSetting() 에서 모바일 레이어 생성
            // 기존에 둘다 생성하고 있었는데, 그렇게 되면 이벤트가 두번 걸림
            return `<div class="ncc-gamestart-btn"></div>`;
        }

        if(platformDataLength > 0) {
            // TL 의 경우 아래와 같이 platformDataLength가 세팅 되어 있는데.
            // 배열 안에 객체가 하나만 있는 경우 다운로드 버튼을 눌렀을때 이동하는 단일 url로 사용한다. 
            // [ { "url": "https://tl.plaync.com/ko-kr/download/index", "target": "_self" } ]
            // 그럼 lineage2 옵션처럼 cnbConfig.useGameStart 의 값을 'gameStart' 로 두고 cnbConfig.gameStart.markup에 anchor 태그를 넣으면 되지 않을까?
            // 아마도 nc-home과 연동 하려고 이렇게 된것 같다. 
            // nc-home 에 다룬로드 버튼을 누르면, platformDownload가 열린다.
            // https://git.ncsoft.net/projects/FRONTEND_DEVELOP/repos/nc-home/browse/_src/js/components/Trailer.ts#316
            if(platformDataLength === 1) {
                innerTmpl += `<a href="${platformData[0]?.url || '#'}" 
                class="ncc-gamestart-btn__platform" 
                target="${platformData[0]?.target || '_blank'}" data-contents="홈_다운로드 버튼_선택">
                    <span class="ncc-gamestart-btn__platform-text">${platformData[0]?.name || downloadTagText}</span>
                </a>`;
            } else {
                innerTmpl += `<button type="button" class="ncc-gamestart-btn__platform" data-contents="홈_다운로드 버튼_선택">
                                <span class="ncc-gamestart-btn__platform-text">${downloadTagText}</span>
                            </button>
                            <div class="ncc-gamestart-layer__platform" platform-layer="pc">
                                ${this.makePlatformDownloadListTmpl(platformData)}
                            </div>`;
            }
        }
        
        return `<div class="ncc-gamestart-btn">${innerTmpl}</div>`;
    }

    async openAlertModal(modalOptions ){
        const ncuiModalConfirm = new ncuiModal.uiAlert();
        return ncuiModalConfirm.open(modalOptions)
    }

    async openConfirmModal( modalOptions){
        const ncuiModalConfirm = new ncuiModal.uiConfirm();
        return ncuiModalConfirm.open(modalOptions)
    }

    // 모달로 사용되어야 할 보간법 적용된 모달옵션 겟
    getTargetMergedModalOptionWithInterpolation(modalMessage){
        const targetModalOption = this.getTargetModalOption(modalMessage.modalOptionList);
        const targetInterpolation = this.getTargetModalInterpolation(modalMessage.interpolationList);

        return targetInterpolation
            ? this.mergeModalOptionToInterpolation(targetModalOption, targetInterpolation)
            : targetModalOption;
    }

    // 사용할 모달옵션 선택 (아직 보간법 미적용))
    getTargetModalOption(modalOptionList){
       const targetModalOptionItem = modalOptionList.find(modalOptionItem => {
            // lang 속성으로 선택
            if(modalOptionItem.lang){
                return modalOptionItem.lang.includes(document.documentElement.lang)
            }
        });

        if(targetModalOptionItem){
            return targetModalOptionItem.modalOption;
        }

        // default
        return modalOptionList[0].modalOption; 
    }

    // 사용할 보간법 선택
    getTargetModalInterpolation(interpolationList){
        // interpolationList 는 옵셔널 이니까
        if(!interpolationList || (Array.isArray(interpolationList) && interpolationList.length < 1)) return null;

        const interpolationItem = interpolationList.find(interpolation=>{
            // data-country 속성으로 선택
            if(interpolation.country){
                return interpolation.country.map(e=>e.toLocaleLowerCase()).includes(this.com?.country?.toLocaleLowerCase())
            }
        });

        if(interpolationItem){
            return interpolationItem.interpolation
        }

        // default
        return interpolationList[0].interpolation; 
    }

    // 모달 옵션에 보간법 적용
    mergeModalOptionToInterpolation(targetModalOption, targetInterpolation){
        return Object.entries(targetInterpolation).reduce((merged, [key, value]) => {
            Object.keys(merged).forEach(optionKey => {
                if (typeof merged[optionKey] === 'string') {
                    merged[optionKey] = merged[optionKey].replace(`\${${key}}`, value);
                }
            });
            return merged;
        }, { ...targetModalOption });
    }

    // 얼럿
    async handleAlerttModalBeforNavigate(modal){
        let targetModalOption = null

        // alert 조건
        if(modal.condition === "isMac"){
            // 맥에서는 애러 나오게 하기
            if(navigator.userAgent.includes('Macintosh')){
                targetModalOption = this.getTargetMergedModalOptionWithInterpolation(modal.message);

                // 타겟이 있다면
                if(targetModalOption){
                    await this.openAlertModal(targetModalOption);
                    
                    throw new Error('맥인경우 무조건 cancel')
                }
            }
        }

        return true;
    }
   

    // 컨펌
    async handleConfirmModalBeforeNavigate(modal){
        let targetModalOption = null

        // alert 조건
        if(modal.condition === "allways"){
            // 항상 컨펌창 나오는 조건임
            targetModalOption = this.getTargetMergedModalOptionWithInterpolation(modal.message);

            // 타겟이 있다면
            if(targetModalOption){
                const result = await this.openConfirmModal(targetModalOption);
        
                if(!result.isConfirmed){
                    throw new Error('confirm 에서 cancel 되었음')
                }
            }
        }

        return true;
    }

    startSetting() {
        const { useGameStart, platformDownload } = this.data;
        
        if(useGameStart === 'platformDownload' && Array.isArray(platformDownload) && platformDownload?.length > 1) {
            if(this.isMobile) {
                // 모바일일 때 다운로드 플랫폼 레이어 생성
                this.appendMobilePlatformLayer();

                const btnMobileLayerClose = document.querySelector('.mobile-gamestart-layer__platform-close');
                btnMobileLayerClose?.addEventListener('click', e => {
                    this.platformLayerActive(false, 'mobile');
                });
            } else {
                // PC 다운로드 버튼 - 레이어 노출/숨김
                const btnDownloadEle = document.querySelector('button.ncc-gamestart-btn__platform');
                btnDownloadEle?.addEventListener('click', e => {
                    const pcLayerEle = document.querySelector('[platform-layer="pc"]');
                    const isActive = pcLayerEle?.classList?.contains('is-active');
                    this.platformLayerActive(!isActive, 'pc');
                });
            }
        }
    }

 // 플랫폼 다운로드 리스트 템플릿
 makePlatformDownloadListTmpl(data = []) {
        // 모바일인 경우 윈도우는 일단 제외
        if(this.isMobile){
            data = data.filter((platform)=>{
              return platform.platform !== "windows";
            })
        }

        // 안드로이드, 아이폰 인경우 플랫폼 리스트 정제 [PSD-17181]
        // isMobile로 체크 하지 않은 이유는... 안드로이드, 아이폰 이외의 것도 있을수 있으므로 
        const isIos = isIosCheck();
        const isAndroid = isAndroidCheck();

        const { purpleCheck } = this.com || {};
        const { isPurpleApp } = purpleCheck;

        if(isAndroid || isIos){
            let TARTGET_PLATFOMR = [];

            // 안드로이드
            if(isAndroid){
                TARTGET_PLATFOMR = ["googlePlay", "oneStore", "galaxyStore", "purple"];
            // 아이폰
            }else if(isIos){
                // 아이폰 + 퍼플 [CSFDT-2339]
                if(isPurpleApp){
                    TARTGET_PLATFOMR = ["appStore"];
                }else{
                    TARTGET_PLATFOMR = ["appStore", "purple"];
                }
            }
            // 정제 시작 
            data = data.filter((platform)=>{
                return TARTGET_PLATFOMR.includes(platform.platform);
            })
        }

        const listTmpl = data.map(v => {

            const templ = `<li class="platform-layer-item">
                <a href="${this.setUrl(v.url)}" class="platform-layer-item__link ${v.platform} ${!!v.icon ? 'no-icon' : ''}" target="${v.target}" >
                    ${!!v.icon ? `<span class="platform-layer-item__link-icon" style="background-image: url(${v.icon})"></span>` : ''}
                    <span class="platform-layer-item__link-name">${v.name}</span>
                </a>
            </li>`;

            // 플랫폼 다운로드 전에 이벤트 걸기
            if(v.beforeNavigate){
                this.setBeforeNavigatePlatformDownload(v);
            }

            return templ;
        });

        return `<ul class="platform-layer-list">${listTmpl.join('')}</ul>`;
    }
    
    // 플랫폼 다운로드 전에 이벤트 걸기
    setBeforeNavigatePlatformDownload(platformDownloadItem){

        // 위임 이벤트로 했음. 어쩔수 없음.
        document.querySelector('body').addEventListener('click', async (e) => {
            const targetElement = e.target.closest(`a.platform-layer-item__link.${platformDownloadItem.platform}`);
            
            // 클릭한 곳 상위에 .target 클래스가 있으면 이벤트 실행
            if (targetElement && e.currentTarget.contains(targetElement)) {
                // 일단 기본 link 이동 끄고
                e.preventDefault();
                
                const {alertModal, confirmModal} = platformDownloadItem.beforeNavigate; 

                try{
                    // Alert 통과
                    if(alertModal){
                        await this.handleAlerttModalBeforNavigate(alertModal);
                    }

                    // Confirm 통과
                    if(confirmModal){
                        await this.handleConfirmModalBeforeNavigate(confirmModal);
                    }

                    // 이제 이동 합시다
                    const href = targetElement.getAttribute('href');
                    const target = targetElement.getAttribute('target') || '_blank';

                    // 직접 다운로드의 경우 window.open 으로 하면 페이지가 깜박임
                    if(platformDownloadItem.platform === "windows"){
                        location.href = href;
                    }else{
                        window.open(href, target);
                    }
                }catch(err){
                    console.error('링크이동 취소됨', err)
                }
            }
        });
    }

    // 모바일에서 사용할 플랫폼 리스트 레이어 생성 (body 하위에 심기위해 makeMarkup()에서 생성하지 않음)
    appendMobilePlatformLayer() {
        const tmpl = `<div class="mobile-gamestart-layer__platform" platform-layer="mobile">
            <div class="mobile-gamestart-layer__platform-inner">
                <button type="button" class="mobile-gamestart-layer__platform-close">
                    <span class="hidden">닫기</span>
                </button>
                ${this.makePlatformDownloadListTmpl(this.data?.platformDownload)}
            </div>
            <span class="mobile-gamestart-layer__platform-bg"></span>
        </div>`;

        document.body.insertAdjacentHTML('beforeend', tmpl);
    }

    documentClickCallback = (e) => {
        const { layerEle, wrapEle } = this.getPlatformLayerElement();
        
        if(!wrapEle.contains(e.target) && (!this.isMobile || (this.isMobile && layerEle.contains(e.target)))) {
            this.setPlatformLayerActiveClass(false);
        }
    }

    // 플랫폼 레이어 영역 외 닫기 기능
    documentClickClose(isActive = false) {
        if(isActive) {
            document.addEventListener('click', this.documentClickCallback);
        } else {
            document.removeEventListener('click', this.documentClickCallback);
        }
    }

    // 플랫폼 다운로드 레이어 엘리먼트 반환
    getPlatformLayerElement() {
        const pcLayerEle = document.querySelector('[platform-layer="pc"]');
        const pcLayerWrapEle = document.querySelector('.ncc-header');
        const mobileLayerEle = document.querySelector('[platform-layer="mobile"]');
        const mobileLayerWrapEle = document.querySelector('.mobile-gamestart-layer__platform-inner');
        let layerEle;
        let wrapEle;

        if(this.isMobile) {
            layerEle = mobileLayerEle;
            wrapEle = mobileLayerWrapEle;
        } else {
            layerEle = pcLayerEle;
            wrapEle = pcLayerWrapEle;
        }

        return { layerEle, wrapEle };
    }

    // 플랫폼 다운로드 레이어 노출/숨김 스타일 제어
    setPlatformLayerActiveClass(isActive = false) {
        const { layerEle } = this.getPlatformLayerElement();

        if(this.isMobile) {
            if(isActive) {
                const liItems = layerEle?.querySelectorAll('.platform-layer-item');
                layerEle?.classList?.add('is-active');
                gsap.set(layerEle, {opacity: 0});
                gsap.set(liItems, {opacity: 0, x: 20});
                gsap.to(layerEle, {opacity: 1, duration: 0.4, ease: 'Quad.easeOut'});
                gsap.to(liItems, {opacity: 1, x: 0, duration: 0.4, delay: 0.1, stagger: 0.1, ease: 'Quad.easeOut'});
            } else {
                gsap.to(layerEle, {opacity: 0, duration: 0.3, ease: 'Quad.easeOut', onComplete: () => {
                    layerEle?.classList?.remove('is-active');
                }});
            }
        } else {
            if(isActive) {
                const ulEle = layerEle?.querySelector('.platform-layer-list');
                const ulHeight = ulEle?.clientHeight || 0;
                layerEle?.classList?.add('is-active');
                gsap.to(layerEle, {height: ulHeight, duration: 0.4, ease: 'Quad.easeOut'});
            } else {
                gsap.to(layerEle, {height: 0, duration: 0.33, ease: 'Quad.easeOut', onComplete: () => {
                    layerEle?.classList?.remove('is-active');
                }});
            }
        }
    }

    // 플랫폼 다운로드 레이어 노출/숨김
    platformLayerActive(isActive = false) {
        this.setPlatformLayerActiveClass(isActive);
        this.documentClickClose(isActive);
    }

    // 퍼플 모바일앱일 때, 플랫폼 다운로드 링크는 외부 브라우저로 실행하도록 url 가공하기 
    // PURPLE_SCHEME_TYPE.EXTERNAL
    setUrl(url = '') {
        console.log("url", url);
        if(!url || typeof url !== 'string') {
            return '#';
        }

        // 퍼플 다운로드의 경우 웹뷰로 이동 https://www.ncpurple.com/?installerCode=linw&country=kr
        // [TODO] setPurpleAppScheme 에서 예외처리 하는게 좋을까?
        if(this.isPurpleApp && !/(\.plaync.com\/|\.ncpurple.com\/)/.test(url)){
            return PurpleUrl.setPurpleAppScheme(PURPLE_SCHEME_TYPE.EXTERNAL, url);
        }else{
            return url;
        }
    }
}

export default PlatformDownload;